// src/pages/Home/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Card from '../../components/Card/Card';
import Button from '../../components/Button/Button';
import DonateButton from '../../components/DonateButton/DonateButton';
import styles from './Home.module.css';
import { trustees } from '../../utils/data/trustees';

const activities = [
  {
    id: 1,
    title: 'Annual Medical Outreach',
    date: 'May 15, 2026',
    location: 'Otukpo',
    description: 'Free health checks and medicines.',
  },
  {
    id: 2,
    title: 'Journal Publication',
    date: 'April 2026',
    description:
      'Latest issue of the Journal of Medical Research and Practice.',
  },
  {
    id: 3,
    title: 'Executive Committee Meeting',
    date: 'March 10, 2026',
    description: 'Quarterly planning meeting.',
  },
];

const Home = () => {
  return (
    <div className={styles.home}>
      {/* Hero - full width */}
      <section className={`${styles.hero} ${styles.fullWidth}`}>
        <div className={styles.heroOverlay}></div>
        <div className={styles.container}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>
              Idoma Medical Doctors Foundation
            </h1>
            <div className={styles.heroBottom}>
              <p className={styles.heroSubtitle}>
                Towards a healthy Idoma nation – Uniting medical professionals
                for community development.
              </p>
              <div className={styles.heroButtons}>
                <DonateButton />
                <Link to="/about">
                  <Button variant="outline" size="medium">
                    Learn More
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Current Activities - contained */}
      <section className={styles.activities}>
        <SectionTitle
          title="Current Activities"
          subtitle="Get involved"
          align="center"
        />
        <div className={styles.cardGrid}>
          {activities.map((activity) => (
            <Card
              key={activity.id}
              title={activity.title}
              subtitle={activity.date}
              variant="elevated"
            >
              <p>{activity.description}</p>
              {activity.location && (
                <p className={styles.location}>
                  <strong>Location:</strong> {activity.location}
                </p>
              )}
              <Link to="/activities" className={styles.readMore}>
                Read more →
              </Link>
            </Card>
          ))}
        </div>
      </section>

      {/* Impact Numbers - full width */}
      <section className={`${styles.impact} ${styles.fullWidth}`}>
        <div className={styles.container}>
          <div className={styles.impactGrid}>
            <div className={styles.impactItem}>
              <span className={styles.impactNumber}>500+</span>
              <span className={styles.impactLabel}>Patients Treated</span>
            </div>
            <div className={styles.impactItem}>
              <span className={styles.impactNumber}>150+</span>
              <span className={styles.impactLabel}>Active Members</span>
            </div>
            <div className={styles.impactItem}>
              <span className={styles.impactNumber}>10</span>
              <span className={styles.impactLabel}>Outreaches</span>
            </div>
            <div className={styles.impactItem}>
              <span className={styles.impactNumber}>5</span>
              <span className={styles.impactLabel}>Journal Issues</span>
            </div>
          </div>
        </div>
      </section>

      {/* Why Donate - contained */}
      <section className={styles.whyDonate}>
        <div className={styles.whyDonateContent}>
          <SectionTitle
            title="Support Our Mission"
            subtitle="Why donate?"
            light
          />
          <p className={styles.whyDonateText}>
            Your donation helps us provide medical outreaches, publish
            research, and support healthcare initiatives across Idoma land.
            Every contribution brings us closer to a healthier community.
          </p>
          <DonateButton />
        </div>
        <div className={styles.whyDonateImage}></div>
      </section>

      {/* Trustees - full width (with square images & rectangular cards) */}
      <section className={`${styles.trustees} ${styles.fullWidth}`}>
        <div className={styles.container}>
          <SectionTitle
            title="Our Trustees"
            subtitle="Leadership"
            align="center"
          />
          <div className={styles.cardGrid}>
            {trustees.map((trustee) => (
              <div key={trustee.id} className={styles.trusteeCard}>
                <div className={styles.trusteeImageWrapper}>
                  <img
                    src={trustee.image}
                    alt={trustee.name}
                    className={styles.trusteeImage}
                  />
                </div>
                <div className={styles.trusteeContent}>
                  <h3 className={styles.trusteeName}>{trustee.name}</h3>
                  <p className={styles.trusteeRole}>{trustee.role}</p>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.centered}>
            <Link to="/leadership">
              <Button variant="outline" size="medium">
                View All Leadership
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Newsletter - contained */}
      <section className={styles.newsletter}>
        <div className={styles.newsletterBox}>
          <h3>Stay Updated</h3>
          <p>Subscribe to our newsletter for the latest news and events.</p>
          <form className={styles.newsletterForm}>
            <input type="email" placeholder="Your email address" required />
            <Button type="submit" variant="primary">
              Subscribe
            </Button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Home;